import * as React from "react";

const SvgPlusIcon = props => <svg width={12} height={12} viewBox="0 0 12 12" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.3332 6.66699H6.6665V11.3337H5.33317V6.66699H0.666504V5.33366H5.33317V0.666992H6.6665V5.33366H11.3332V6.66699Z" fill="white" /></svg>;

export default SvgPlusIcon;